module.exports = __webpack_public_path__ + "static/media/NotoKufiArabic-Bold.952e8629.woff";